export default "__VITE_ASSET__6XtA_k_$__"